<template>
  <div class="script-code-editor">
    <textarea ref="textarea" />
  </div>
</template>

<script>
import CodeMirror from 'codemirror'
import 'codemirror/lib/codemirror.css'
import 'codemirror/theme/tomorrow-night-bright.css'
import 'codemirror/mode/shell/shell'

export default {
  name: 'ScriptCodeEditor',
  props: {
    value: {
      type: String,
      default: ''
    },
    validateEvent: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      cm: null
    }
  },
  watch: {
    value(val) {
      if (!this.cm) return
      const cur = this.cm.getValue()
      const next = val != null ? String(val) : ''
      if (next !== cur) {
        const scroll = this.cm.getScrollInfo()
        this.cm.setValue(next)
        this.cm.scrollTo(scroll.left, scroll.top)
      }
    }
  },
  mounted() {
    this.cm = CodeMirror.fromTextArea(this.$refs.textarea, {
      lineNumbers: true,
      mode: 'shell',
      theme: 'tomorrow-night-bright',
      lineWrapping: true,
      tabSize: 2,
      indentUnit: 2
    })
    this.cm.setValue(this.value != null ? String(this.value) : '')
    this.cm.on('change', cm => {
      const v = cm.getValue()
      this.$emit('input', v)
      if (this.validateEvent && this.$parent && this.$parent.$options.componentName === 'ElFormItem') {
        this.$parent.$emit('el.form.change', [v])
      }
    })
    this.cm.on('blur', () => {
      if (this.validateEvent && this.$parent && this.$parent.$options.componentName === 'ElFormItem') {
        this.$parent.$emit('el.form.blur', [this.cm.getValue()])
      }
    })
    this.$nextTick(() => {
      this.cm.refresh()
    })
  },
  beforeDestroy() {
    if (this.cm) {
      this.cm.toTextArea()
      this.cm = null
    }
  }
}
</script>

<style lang="scss" scoped>
.script-code-editor {
  border: 1px solid #333;
  border-radius: 4px;
  overflow: hidden;

  ::v-deep .CodeMirror {
    height: 468px;
    font-size: 13px;
    line-height: 1.28;
  }

  ::v-deep .CodeMirror pre.CodeMirror-line,
  ::v-deep .CodeMirror pre.CodeMirror-line-like {
    line-height: 1.28;
    padding: 0 0 1px 0;
  }
}
</style>
